"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var YAxis_1 = require("../../../parts/YAxis");
exports.default = YAxis_1.YAxis;
//# sourceMappingURL=YAxis.js.map